// extracted by mini-css-extract-plugin
module.exports = {"button":"GDPRModal-module_button_2o1tU","link":"GDPRModal-module_link_1ow1U"};